import script from "./EditShipping.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditShipping.vue?vue&type=script&setup=true&lang=ts"

import "./EditShipping.vue?vue&type=style&index=0&id=698f96cb&lang=css"

const __exports__ = script;

export default __exports__